export default __webpack_public_path__ + "static/media/explore-cover.16bb4888.jpg";